import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "tw-space-y-4" }
const _hoisted_2 = { class: "tw-flex tw-flex-wrap tw-items-baseline tw-justify-between tw-gap-3" }
const _hoisted_3 = { class: "tw-text-lg tw-font-semibold tw-tracking-tight tw-text-slate-900" }
const _hoisted_4 = { class: "tw-text-sm tw-text-slate-600" }
const _hoisted_5 = { class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white tw-p-4" }
const _hoisted_6 = { class: "tw-mt-2 tw-space-y-1 tw-text-sm tw-text-slate-700" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white tw-p-4" }
const _hoisted_10 = { class: "tw-mt-2 tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-x-6 tw-gap-y-2 tw-text-sm tw-text-slate-700" }
const _hoisted_11 = { class: "md:tw-col-span-2" }
const _hoisted_12 = { class: "md:tw-col-span-2" }
const _hoisted_13 = { class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white tw-p-4" }
const _hoisted_14 = { class: "tw-mt-3 tw-space-y-2" }
const _hoisted_15 = { class: "tw-font-medium tw-text-slate-900" }
const _hoisted_16 = ["href"]
const _hoisted_17 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, " Carrier: " + _toDisplayString(_ctx.brokerCarrierAssociation.customCarrierName), 1),
      _createElementVNode("div", _hoisted_4, "Status: " + _toDisplayString(_ctx.brokerCarrierAssociation.onboardingStatus), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "tw-text-sm tw-font-semibold tw-text-slate-900" }, "General Information", -1)),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, "Email: " + _toDisplayString(_ctx.carrier.email), 1),
        _createElementVNode("div", null, "Onboarding Status: " + _toDisplayString(_ctx.brokerCarrierAssociation.onboardingStatus), 1),
        (_ctx.brokerCarrierAssociation.onboardingStatus === 'In Progress')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _cache[0] || (_cache[0] = _createTextVNode(" Onboarding link: ", -1)),
              _createElementVNode("a", {
                class: "tw-font-medium tw-text-slate-900 hover:tw-underline",
                href: _ctx.getCarrierOnboardingUrl()
              }, "link", 8, _hoisted_8)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "tw-text-sm tw-font-semibold tw-text-slate-900" }, "Onboarding Information", -1)),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", null, "Primary Contact: " + _toDisplayString(_ctx.carrier.primaryContactName), 1),
        _createElementVNode("div", null, "Primary Contact Phone #: " + _toDisplayString(_ctx.carrier.primaryContactPhoneNumber), 1),
        _createElementVNode("div", null, "Accounting Email: " + _toDisplayString(_ctx.carrier.accountingEmail), 1),
        _createElementVNode("div", null, "MC #: " + _toDisplayString(_ctx.carrier.mcNumber), 1),
        _createElementVNode("div", null, "DOT #: " + _toDisplayString(_ctx.carrier.dotNumber), 1),
        _createElementVNode("div", null, "FID #: " + _toDisplayString(_ctx.carrier.fidNumber), 1),
        _createElementVNode("div", null, "Dispatch Phone #: " + _toDisplayString(_ctx.carrier.dispatchPhoneNumber), 1),
        _createElementVNode("div", null, "After Hours Phone #: " + _toDisplayString(_ctx.carrier.afterHoursPhoneNumber), 1),
        _createElementVNode("div", null, "Fax #: " + _toDisplayString(_ctx.carrier.faxNumber), 1),
        _createElementVNode("div", _hoisted_11, "Address: " + _toDisplayString(_ctx.fullAddress(_ctx.carrier.officeAddress)), 1),
        _createElementVNode("div", null, "# Owner/Operator Drivers: " + _toDisplayString(_ctx.carrier.numOwnerOpDrivers), 1),
        _createElementVNode("div", null, "# Company Drivers: " + _toDisplayString(_ctx.carrier.numCompanyDrivers), 1),
        _createElementVNode("div", null, "Transports TL: " + _toDisplayString(_ctx.carrier.doesTransportTl ? _ctx.carrier.doesTransportTl.toString() : 'false'), 1),
        _createElementVNode("div", null, "Transports LTL: " + _toDisplayString(_ctx.carrier.doesTransportLtl ? _ctx.carrier.doesTransportLtl.toString() : 'false'), 1),
        _createElementVNode("div", _hoisted_12, "Preferred Lanes: " + _toDisplayString(_ctx.carrier.preferredLanes), 1),
        _createElementVNode("div", null, "# Tractors: " + _toDisplayString(_ctx.carrier.numTractors), 1),
        _createElementVNode("div", null, "# 45 Flat Vans: " + _toDisplayString(_ctx.carrier.num45FlatVans), 1),
        _createElementVNode("div", null, "# 48 Flat Vans: " + _toDisplayString(_ctx.carrier.num48FlatVans), 1),
        _createElementVNode("div", null, "# 53 Flat Vans: " + _toDisplayString(_ctx.carrier.num53FlatVans), 1),
        _createElementVNode("div", null, "# Reefers: " + _toDisplayString(_ctx.carrier.numReefers), 1),
        _createElementVNode("div", null, "# Step Decks: " + _toDisplayString(_ctx.carrier.numStepDecks), 1),
        _createElementVNode("div", null, "# 4 Tarps: " + _toDisplayString(_ctx.carrier.num4Tarps), 1),
        _createElementVNode("div", null, "# 6 Tarps: " + _toDisplayString(_ctx.carrier.num6Tarps), 1),
        _createElementVNode("div", null, "# 8 Tarps: " + _toDisplayString(_ctx.carrier.num8Tarps), 1),
        _createElementVNode("div", null, "# Coil Racks: " + _toDisplayString(_ctx.carrier.numCoilRacks), 1),
        _createElementVNode("div", null, "# Pipe Stakes: " + _toDisplayString(_ctx.carrier.numPipeStakes), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "tw-text-sm tw-font-semibold tw-text-slate-900" }, "Documents", -1)),
      _createElementVNode("div", _hoisted_14, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brokerCarrierAssociation.onboardingDocs, (onboardingDoc) => {
          return (_openBlock(), _createElementBlock("div", {
            key: onboardingDoc.id,
            class: "tw-text-sm tw-text-slate-700"
          }, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.displayDocTypeName(onboardingDoc.docType)), 1),
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "tw-text-slate-500" }, " — ", -1)),
            _createElementVNode("a", {
              class: "tw-font-medium tw-text-slate-900 hover:tw-underline",
              href: onboardingDoc.docFileUrl,
              target: "_blank"
            }, _toDisplayString(onboardingDoc.docFileUrl), 9, _hoisted_16)
          ]))
        }), 128)),
        _createElementVNode("a", {
          class: "tw-inline-flex tw-items-center tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white/70 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 hover:tw-bg-white",
          href: _ctx.combinedOnboardingDocsPdfUrl,
          target: "_blank"
        }, " Download all data and files as single PDF ", 8, _hoisted_17)
      ])
    ])
  ]))
}